import constants from '../constants';

export const getDeal = (state) => state.deals.deal;

export const getDealer = (state) => state.deals.dealer;

export const getPayments = (state) => state.deals.payments;

export const getError = (state) => state.deals[constants.ERROR_KEY];

export const getFetching = (state) => state.deals[constants.FETCHING_KEY];
